module.exports = __webpack_public_path__ + "static/img/silhouette_01.d1ff776.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_01.png
// module id = OzL8
// module chunks = 0